import Loading from '../Loading/Loading';
import React from "react";
import "./Button.css";

/**
 * Button
 * ----------
 * Reusable button component following the DOME design system.
 *
 * Props:
 *   variant: "primary" | "secondary" | "outline" | "ghost" | "danger" | "success" (default: "primary")
 *   size: "sm" | "md" | "lg" (default: "md")
 *   isLoading: boolean
 *   iconOnly: boolean
 *   icon: ReactNode
 *   className: string
 *   disabled: boolean
 *   onClick: function
 *   children: ReactNode
 *   type: "button" | "submit" | "reset" (default: "button")
 */
export default function Button({
  variant = "primary",
  size = "md",
  isLoading = false,
  iconOnly = false,
  icon,
  className = "",
  disabled = false,
  onClick,
  children,
  type = "button",
  ...props
}) {
  const baseClass = "dome-btn";
  const variantClass = `dome-btn--${variant}`;
  const sizeClass = size !== "md" ? `dome-btn--${size}` : "";
  const loadingClass = isLoading ? "dome-btn--loading" : "";
  const iconOnlyClass = iconOnly ? "dome-btn--icon-only" : "";

  const finalClassName = [
    baseClass,
    variantClass,
    sizeClass,
    loadingClass,
    iconOnlyClass,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={finalClassName}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
    >
      {isLoading && <Loading variant="spinner" />}
      {!isLoading && icon && <span className="dome-btn__icon">{icon}</span>}
      {!iconOnly && children}
    </button>
  );
}
